import { Button, Form, InputNumber, Space } from "antd";
import { useEffect, useReducer, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../interfaces/users";
import { api } from "../../config";
import { SeniorityInterface } from "../../interfaces/seniority";
import { toast } from "react-toastify";

export const Config = () => {
  const { token, user } = useSelector((state: AuthenticationState) => state);
  const {
    isLoading,
    data: seniorities,
    isError,
    refetch,
  } = useQuery<SeniorityInterface[]>(["seniority"], () =>
    api(token).get("/seniority")
  );
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const updateAssemblersConfig = async (
    values: Record<string, number | null>
  ) => {
    setLoading(true);
    try {
      const requests =
        seniorities
          ?.filter((seniority) => seniority.name in values)
          .map((seniority) => {
            const newValue = values[seniority.name];
            if (
              newValue === null ||
              seniority.hourlyRate === Number(newValue)
            ) {
              return Promise.resolve();
            }
            return api(token).put(`seniority/${seniority.id}`, {
              hourlyRate: Number(newValue),
            });
          }) || [];

      await Promise.all(requests);
      refetch();
      toast.success("Configurações salvas com sucesso!");
    } catch (error: any) {
      toast.error("Ocorreu um erro ao salvar as configurações dos Montadores");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (seniorities) {
      const values: Record<string, number> = {};
      seniorities.forEach((seniority) => {
        values[seniority.name] = seniority.hourlyRate;
      });
      form.setFieldsValue(values);
    }
  }, [seniorities, form]);

  return (
    <div>
      <div className="gap-4">
        <h3>Porcentagem de Comissão</h3>
        <Form
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          layout="vertical"
          style={{ maxWidth: 700, maxHeight: 500, overflowY: "auto" }}
          onFinish={updateAssemblersConfig}
        >
          {seniorities?.map((seniority) => (
            <Form.Item name={seniority.name} label={seniority.name}>
              <InputNumber
                disabled={isLoading}
                formatter={(value) =>
                  `${value} %`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={
                  (value) =>
                    value?.replace(/R\$\s?|(,*)/g, "") as unknown as number // Colocado 'as' como esta na documentação
                }
                style={{ width: 304 }}
              />
            </Form.Item>
          ))}
          <Space className="mt-4 flex w-full justify-start">
            <Button loading={loading} type="primary" htmlType="submit">
              Salvar
            </Button>
          </Space>
        </Form>
      </div>
    </div>
  );
};
